{
    "text": "Text Field",
    "address": "Address",
    "date": "Date",
    "number": "Number",
    "singleSelect": "Single Select",
    "tag": "Tag"
}